import { render, staticRenderFns } from "./BookingVOCPop.vue?vue&type=template&id=536c33e2&scoped=true"
import script from "./BookingVOCPop.vue?vue&type=script&lang=js"
export * from "./BookingVOCPop.vue?vue&type=script&lang=js"
import style0 from "./BookingVOCPop.vue?vue&type=style&index=0&id=536c33e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c33e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536c33e2')) {
      api.createRecord('536c33e2', component.options)
    } else {
      api.reload('536c33e2', component.options)
    }
    module.hot.accept("./BookingVOCPop.vue?vue&type=template&id=536c33e2&scoped=true", function () {
      api.rerender('536c33e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BookingVOCPop.vue"
export default component.exports